/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { Table } from 'reactstrap'
import Pagination from 'react-js-pagination'

import {
  WhiteGreenBtn,
  RedBtn,
  RedBtnDisabled,
  GreenBtn,
} from 'Stories/Button/Button.stories'

import arrowDown from 'Shared/img/arrow-down.svg'
import arrowUp from 'Shared/img/arrow-up.svg'

const AdminPanel = ({
  users,
  totalUsers,
  handleLoginAs,
  handleValidate,
  isSearch,
  setFoundUsers,
  allFoundUsers,
  getUsers,
  handleBlockConfirmation,
}) => {
  const [activePage, setActivePage] = useState(1)
  const [curSortingDir, setSortingDir] = useState('')
  const [curSortStatus, setCurSortStatus] = useState('')

  useEffect(() => {
    getUsers(activePage)
  }, [])

  const handleDirChange = curDir => {
    setCurSortStatus('verified')
    if (curDir === '' || curDir === 'DESC') {
      setSortingDir('ASC')
      getUsers(activePage, 'verified', 'ASC')
    } else {
      setSortingDir('DESC')
      getUsers(activePage, 'verified', 'DESC')
    }
  }

  const handlePageChange = pageNumber => {
    const offset = (pageNumber - 1) * 50
    setActivePage(pageNumber)

    if (isSearch) {
      setFoundUsers(allFoundUsers.slice(offset, offset + 50))
    } else {
      getUsers(pageNumber, curSortStatus, curSortingDir)
    }
  }

  const SortButton = ({ title, handleClick }) => (
    <div className="sort-button__container">
      <button
        className="sort-button__button"
        type="button"
        onClick={handleClick}
      >
        {title}
      </button>
      <div className="sort-button__arrows-wrapper">
        <img src={arrowUp} alt="" height="4" width="6" />
        <img src={arrowDown} alt="" height="4" width="6" />
      </div>
    </div>
  )

  return (
    <>
      {!isEmpty(users) ? (
        <Table responsive striped>
          <thead>
            <tr>
              <th>Full name</th>
              <th>Email</th>
              {isSearch && <th>Role</th>}
              <th>Joined time</th>
              <th>Last activity</th>
              <th>User IP</th>
              {!users[0].isArtist ? (
                <th>
                  <SortButton
                    title="Validate"
                    handleClick={() => handleDirChange(curSortingDir)}
                  />
                </th>
              ) : (
                <th />
              )}
              <th />
            </tr>
          </thead>
          <tbody>
            {users.map(
              ({
                first_name,
                last_name,
                email,
                createdAt,
                last_activity,
                ip,
                id,
                isArtist,
                is_blocked,
                blocked_at,
                in_blacklist,
                verified,
                verified_at,
                blacklist_country,
              }) => {
                const disabled = is_blocked || in_blacklist
                return (
                  <tr key={`${first_name}${id}`}>
                    <td>
                      {first_name} {last_name}
                    </td>
                    <td>{email}</td>
                    {isSearch && <td>{isArtist ? 'Artist' : 'Curator'}</td>}
                    <td>{moment(createdAt).fromNow()}</td>
                    <td>{moment(last_activity).fromNow()}</td>
                    <td>{ip}</td>
                    {!isArtist ? (
                      <td>
                        {blacklist_country && (
                          <>
                            <span>black list</span>&nbsp;
                            {blocked_at && blocked_at !== null && (
                              <span> {moment(blocked_at).fromNow()}</span>
                            )}
                            &nbsp;
                          </>
                        )}
                        {is_blocked && !blacklist_country && (
                          <>
                            <span>blocked</span>&nbsp;
                            {blocked_at && blocked_at !== null && (
                              <span> {moment(blocked_at).fromNow()}</span>
                            )}
                            &nbsp;
                          </>
                        )}
                        {verified && !is_blocked && !in_blacklist && (
                          <>
                            <span>validated</span>&nbsp;
                            {verified_at !== null ? (
                              <span> {moment(verified_at).fromNow()}</span>
                            ) : null}
                            &nbsp;
                          </>
                        )}
                        {!verified && !is_blocked && !in_blacklist && (
                          <WhiteGreenBtn
                            className="cancel-btn"
                            color="whiteGreen"
                            onClick={() => handleValidate(id)}
                          >
                            Validate
                          </WhiteGreenBtn>
                        )}
                      </td>
                    ) : (
                      <td />
                    )}

                    <td style={{ display: 'flex' }}>
                      <GreenBtn
                        color="green"
                        style={{ marginRight: '10px' }}
                        onClick={() => handleLoginAs(id, isArtist)}
                        onTouchStart={() => handleLoginAs(id, isArtist)}
                      >
                        Login As
                      </GreenBtn>
                      {!isArtist && !disabled && (
                        <RedBtn
                          color="red"
                          onClick={() => handleBlockConfirmation(id)}
                        >
                          Block
                        </RedBtn>
                      )}
                      {!isArtist && disabled && (
                        <RedBtnDisabled color="redDisabled" disabled>
                          Blocked
                        </RedBtnDisabled>
                      )}
                    </td>
                  </tr>
                )
              }
            )}
          </tbody>
        </Table>
      ) : (
        <p className="campaign-not-found">Users not found</p>
      )}
      <div className="pagination-bottom">
        {
          <Pagination
            activePage={activePage}
            itemsCountPerPage={50}
            pageRangeDisplayed={5}
            totalItemsCount={totalUsers}
            onChange={handlePageChange}
          />
        }
      </div>
    </>
  )
}

export default AdminPanel
